<template>
    <v-card>
    <v-tabs v-model="tab" id="usernametabs"  center-active>
        <v-tab
            v-for="(objs, i) in userobjs"
            :key="i"
        >
        {{objs.username}} {{mode === 2? '('+(objs.totalpoints===undefined?'*':objs.totalpoints)+')':''}} {{mode > 0 ? (objs.done? '&#10003;':'*'):''}} 
        <v-icon color="warning" class="ml-2" v-if="mode == 0" @click="removePerson(objs)">mdi-account-remove-outline</v-icon>
        </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
        <v-tab-item
            v-for="(objs, i) in userobjs"
            :key="i"
        >
            <v-card>
            <v-card-title>
                <v-row v-if="mode === 0">
                    <v-col cols="8">
                        <v-text-field readonly v-model="objs.username" 
                            label="姓名" append-icon="mdi-magnify" :error="!objs.userid" class="text-caption"
                            @click:append='selectUser(objs)'></v-text-field>
                    </v-col>
                    <v-col cols='4'>
                        <v-text-field readonly :value="getUserTotalString(objs)" type="number" label="总分" class="text-caption">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-expansion-panels multiple v-model="exp_array[i].exp">
                    <v-expansion-panel v-for="(obj, i2) in objs.objectives" :key="i2">
                        <v-expansion-panel-header  class="text-body-1">
                            {{i2+1}}.{{obj.name}} {{getObjectiveTotalString(obj)}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-expansion-panels multiple accordion v-model="exp_array[i].objs[i2]">
                                <v-expansion-panel  v-for="(item, i3) in obj.items" :key="i3">
                                    <v-expansion-panel-header  class="text-button">
                                        {{i2+1}}.{{i3+1}}.{{item.name}} {{getItemTotalPointsString(item)}}
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <template>
                                            <div>
                                                <template v-if="mode === 0">
                                                    <v-row>
                                                        <v-col cols="6" md="4">
                                                            <v-text-field readonly :value="getRateDepartmentNames(item)" 
                                                                label="考核部门" append-icon="mdi-magnify" 
                                                                class="text-caption"
                                                                :error="checkRateDepartments(item)"
                                                                @click:append='selectDepartment(item)'></v-text-field>
                                                        </v-col>
                                                        <v-col cols="1" md="6"></v-col>
                                                        <v-col cols="4" md="2">
                                                            <v-text-field v-model.number="item.total" type="number" label="分值">
                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row v-for="(c, i4) in item.creteria" :key="i4">
                                                        <v-col cols="8">
                                                            <v-text-field class="text-caption" v-model="c.name" 
                                                                :prefix="(i4+1).toString()"
                                                                label="标准">
                                                            </v-text-field>
                                                        </v-col>
                                                        <v-col cols="1" md="2"></v-col>
                                                        <v-col cols="4" md="2">
                                                            <v-text-field :value="getCreteriaPointsShowString(c)" readonly label="得分项">

                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <template v-if="mode === 1">
                                                    <v-row>
                                                        <v-col cols="12">
                                                            <v-radio-group v-model="item.selectedCre" column dense>
                                                                <v-radio v-for="(c, i4) in item.creteria" :key="i4"
                                                                    :label="c.name+'    ('+c.points+')'" :value="c"
                                                                >
                                                                    <template v-if="needInput(c, item)" v-slot:label>
                                                                        <v-row>
                                                                            <v-col cols="12" md="10">
                                                                                <div>
                                                                                    <v-row>
                                                                                        <v-col cols="12" md="4">
                                                                                            <span>{{c.name+' '+getSliderLabel(c, item)}}</span>
                                                                                        </v-col>
                                                                                        <v-col cols="12" md="8">
                                                                                            <div>
                                                                                            <v-slider v-if="c.min !== undefined || c.isPercent"
                                                                                                :disabled="item.selectedCre != c"
                                                                                                :value="getSliderValue(c)"
                                                                                                @end="sliderChanged(c, $event)"
                                                                                                :min="c.min" :max="c.max"
                                                                                                thumb-color="primary"
                                                                                                thumb-label="always"
                                                                                                class="ml-2"
                                                                                                >
                                                                                                <template v-slot:prepend>
                                                                                                    <v-icon
                                                                                                        color="primary"
                                                                                                        @click="decrement(c)"
                                                                                                    >
                                                                                                        mdi-minus
                                                                                                    </v-icon>
                                                                                                </template>

                                                                                                <template v-slot:append>
                                                                                                    <v-icon
                                                                                                        color="primary"
                                                                                                        @click="increment(c)"
                                                                                                    >
                                                                                                        mdi-plus
                                                                                                    </v-icon>
                                                                                                </template>
                                                                                            </v-slider>
                                                                                            <v-text-field v-else :disabled="item.selectedCre != c"
                                                                                                v-model.number="c.points"
                                                                                                label="请输入分值"
                                                                                                type="number" class="ml-2">
                                                                                            </v-text-field>
                                                                                            </div>
                                                                                        </v-col>
                                                                                    </v-row>
                                                                                </div>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                </v-radio>
                                                            </v-radio-group>
                                                        </v-col>
                                                        <v-col cols="2">
                                                            <v-btn color="" class="ml-2 mt-2" v-if="item.selectedCre"
                                                                @click="enableComment(item)"
                                                                > 
                                                                <v-icon left>mdi-clipboard-edit-outline</v-icon>
                                                                注释
                                                            </v-btn>
                                                        </v-col>
                                                        <v-col cols="8">
                                                            <v-text-field v-if="item.enableComment || (item.selectedCre && item.selectedCre.comment)"
                                                                :disabled="!item.enableComment"
                                                                v-model="item.selectedCre.comment"
                                                                type="text" class="ml-2">
                                                            </v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </template>
                                                <template v-if="mode === 2">
                                                    <v-col cols="12">
                                                        <v-radio-group readonly :value="getSelectedCreteriaId(item)" column dense>
                                                            <v-radio v-for="(c, i4) in item.creteria" :key="i4"
                                                                :label="getCreteriaScoreLabel(c)" :value="c._id">

                                                            </v-radio>
                                                        </v-radio-group>
                                                    </v-col>
                                                    <v-col cols="11">
                                                        <template v-for="(rd) in item.ratedepartments">
                                                            <v-text-field v-if="rd.comment" :value="rd.name+' : '+rd.comment" disabled :key="rd.name">

                                                            </v-text-field>
                                                        </template>
                                                    </v-col>
                                                </template>

                                            </div>
                                        </template>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>
            <v-card-actions>
                <v-row>
                    <v-col cols="8"></v-col>
                    <v-col cols="4">
                        <v-chip color="primary" class="float-right">
                            <v-icon @click="go2nextuser" :disabled="tab >= userobjs.length-1" right>mdi-account-arrow-right-outline</v-icon>
                        </v-chip>
                    </v-col>
                </v-row>
            </v-card-actions>
            </v-card>
        </v-tab-item>
    </v-tabs-items>
    </v-card>
</template>

<script>
import ddhelper from '@/utils/ddhelper.js'
import { mapState } from 'vuex'

export default {
    props:{
        value:{type: Array, default(){return []}, validator: (value) => {
            console.log(`ObjectiveCard validator ${JSON.stringify(value)}`)
            return true
        }},
        mode: {type: Number}, //0:design, 1:rating, 2:review
        sequencenum:{type: Number},
        highlightUserId:{Type:String}
    }, //mode:0: rating, 0: edit
    name: 'ObjectiveCard',
    data: function() {
        return {
            tab:0,
            exp_array: [],
            userobjs: this.value
        }
    },
    computed: {
        ...mapState(['departmentsettings'])
    },
    created() {
        this.expandAll(this.userobjs)
        this.highlightUser()
        console.log(`objective card created`)
    },
    watch: {
        userobjs: {
            deep: true,
            handler: function(value) {
                console.log(`watch userobjs changed:${value.length}`)
                this.expandAll(value)
                this.$emit('input', value)
                this.$emit('changed')
            }
        },
        value: {
            deep: true,
            handler: function(value) {
                console.log(`watch value changed`)
                this.userobjs = value
                this.expandAll(value)
                this.highlightUser()
            }
        },
        sequencenum: {
            deep: true,
            handler: function(value) {
                console.log(`sequencenum changed: ${value}`)
            }
        }
    },
    methods: {
        async selectDepartment(item) {
            // console.log(`selectDepartment:${this.getRateDepartmentNames(item)}`)
            item.ratedepartments = await ddhelper.selectDepartment(6)
            //  console.log(`selectDepartment after:${this.getRateDepartmentNames(item)}`)
        },
        
        selectUser: async function(objs) {
            const users = await ddhelper.selectUser()
            if (users) {
                objs.username = users[0].username
                objs.userid = users[0].userid
            }
        },
        expandAll(userobjs) {
            console.log(`expand all`)

            const me = this
            me.exp_array = []
            userobjs.forEach((user) => {
                const userinfo = {exp:Array.from(Array(user.objectives.length),(x,i)=>i), objs:[]}
                me.exp_array.push(userinfo)

                user.objectives.forEach((obj) => {
                    userinfo.objs.push(me.mode != 2?Array.from(Array(obj.items.length),(x,i)=>i):[])
                })
            })
        },
        highlightUser() {
            if (!this.highlightUserId) return

            const me = this
            const tabIndex = me.userobjs.findIndex(uo => uo.userid === me.highlightUserId)
            if (tabIndex != -1) me.tab = tabIndex
        },
        getUserTotalString(objs) {
            return objs.totalpoints = objs.objectives.reduce((acc, obj)=>obj.totalpoints + acc, 0)
        },
        getRateDepartmentNames(item) {
            return item.ratedepartments.map(d => d.name).join(',')
        },
        checkRateDepartments(item) {
            return item.ratedepartments.some(d => !d.id)
        },
        go2nextuser() {
            this.tab++
            this.$vuetify.goTo('#pagetitle', {duration:100, offset:0, easing: 'easeInOutCubic'})
        },
        getItemTotalPointsString(item) {
            if (this.mode == 0) return `(${item.total})`
    
            if (this.mode !== 2) return ''

            return item.ratedepartments.reduce((acc, rd, index) => 
                `${acc}${index === 0? '':','} ${rd.name}:${rd.points==undefined?'*':rd.points}`, item.ratedepartments.length === 1 ? '(':`(总分:${item.totalpoints===undefined?'*':item.totalpoints}`) + ')'
        },
        getObjectiveTotalString(obj) {
            if (this.mode == 0) {
                return obj.totalpoints = `(${obj.items.reduce((acc, item)=>item.total + acc, 0)})`
            }

            if (this.mode != 2) return ''

            return '('+(obj.totalpoints===undefined?'*':obj.totalpoints)+')'
        },
        getSelectedCreteriaId(item) {
            return item.ratedepartments && item.ratedepartments.length > 0 ? item.ratedepartments[0].creteriaid:null
        },
        getCreteriaScoreLabel(creteria) {
            return `${creteria.name}${creteria.points != undefined? '('+creteria.points+')':''}`
        },
        getCreteriaPointsShowString(c) {
            if (c.isPercent) {
                return `(${c.min}% ~ ${c.max}%) * ${c.points}`
            } else if (c.min != undefined) {
                return `${c.min} ~ ${c.max}`
            } else {
                return c.points
            }

        },
        sliderChanged(creteria, number) {
            if (creteria.old) creteria.old = false; //mark this as updated.
            if (creteria.isPercent) {
                this.$set(creteria, 'percentvalue', number)
                this.$set(creteria, 'points', Math.round(creteria.fullpoints * number / 100))
            } else {
                this.$set(creteria, 'points', number)
            }
            console.log(`sliderChanged:${creteria.creteriaid}-${number}-${creteria.points}`)
        },
        getSliderValue(creteria) {
            console.log(`getSliderValue:${creteria.isPercent}-${creteria.percentvalue}-${creteria.points}-${creteria.min}-${creteria.max}`)
            let val
            if (creteria.isPercent) {
                if (creteria.percentvalue != undefined) val = creteria.percentvalue
                else val = creteria.max
            } else {
                val = creteria.points
            }
            
            return isNaN(val) ? creteria.min : val
        },
        decrement(c) {
            let val = this.getSliderValue(c)
            --val
            if (val < c.min) val = c.min
            this.sliderChanged(c, val)
        },
        increment(c) {
            let val = this.getSliderValue(c)
            ++val
            if (val > c.max) val = c.max
            this.sliderChanged(c, val)
        },
        getSliderLabel(creteria, item) {

            console.log(`getSliderLabel:${creteria.name}-${creteria.points}`)

            if (item.selectedCre != creteria) return ""
        
            if (creteria.isPercent === undefined) return creteria.points != undefined ? `${creteria.points}` : ''

            if (creteria.percentvalue == undefined) return `${creteria.points}`

            return `${creteria.percentvalue}% * ${creteria.fullpoints} = ${creteria.points}`
        },
        needInput(cr, item) {
            return  item.creteria.length == 1 //only one creteria for the item, means need input
                        || cr.points === undefined 
                        || cr.points === null
                        || cr.min !== undefined || cr.max !== undefined
                        || cr.isPercent
        },
        enableComment(item) {
            this.$set(item, "enableComment", !item.enableComment)
        },
        removePerson(objs) {
            this.$emit('removeUserPerf', objs)
        }
    }
}
</script>

<style>
    .v-expansion-panel-content__wrap, .v-card__text {
        padding-right:2px !important;
    }
</style>